import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { SubscribeInLife } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import {
  PledgeRead,
  Parameters,
} from '@app/forms/subscription/definition/interface/Pledge';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<SubscribeInLife> = {
      investmentDurationViager: [
        parameters?.investmentDurationViager != null
          ? parameters.investmentDurationViager
          : true,
        [this.prFormService.RefreshEveryValidators()],
      ],
      investmentDurationYear: [
        parameters?.investmentDurationYear || null,
        [
          this.prFormService.AddValidatorsBasedOnCondition(
            this.prFormService.isTargetControlValueEqualTo(
              'investmentDurationViager',
              false,
            ),
            Validators.required,
          ),
        ],
      ],
    };

    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    return { ...this.form.value };
  }
}
